import dayjs from 'dayjs'

import { ActionButtonVariant } from '../../components/ActionButton/styled'
import { averageScore, numberOfDays } from '../../helpers/OfferHelpers'
import type { Offer } from '../../rest/types/Offer'
import Router from '../../routes/Router'
import routes from '../../routes/definitions'

import { ImageTransformer } from './ImageTransformer'

export const OfferCardTransformer = ({
  offer,
  categoryName,
  isLogin,
  t,
}: {
  offer: Offer
  categoryName?: string
  isLogin: boolean
  t: any
}) => {
  const average =
    offer?.feedbacks &&
    averageScore(offer.feedbacks.map((i: any) => parseInt(i?.rating)))
  const isExpired =
    offer?.card?.[0]?.endDate && dayjs(offer?.card?.[0]?.endDate).isBefore()

  return {
    link: {
      href: Router.getRouteUrl(routes.offer, {
        slug: offer?.slug,
      }),
    },
    title: offer?.name ?? '',
    category: categoryName,
    description: offer?.shortDescription,
    image: ImageTransformer(offer?.image as any),
    ...(average > 0 && {
      score: {
        totalStars: 5,
        activeStars: average,
      },
    }),
    ...(offer?.card?.[0]?.__component === 'offer.type-1' &&
      !isExpired && {
        priceDiscountLeft: offer?.card?.[0]?.dateLabel,
        priceWithReduction: `${t(
          'symbol_before_day_abbreviated'
        )} ${numberOfDays(offer?.card?.[0]?.endDate)} ${t('day_abbreviated')}`,
      }),
    ...(offer?.card?.[0]?.__component === 'offer.type-2' && {
      priceWithoutReduction: offer?.card?.[0]?.publicPrice,
      priceWithReduction: offer?.card?.[0]?.price,
      priceWithReductionPrefix: t('price_with_reduction_prefix'),
    }),
    ...(offer?.card?.[0]?.__component === 'offer.type-3' && {
      priceDiscountLeft: offer?.card?.[0]?.discount,
      priceLabelLeft: offer?.card?.[0]?.priceLabel,
      priceWithReduction: offer?.card?.[0]?.price,
      priceWithReductionPrefix: t('price_with_reduction_prefix'),
    }),
    ...(offer?.card?.[0]?.__component === 'offer.type-4' && {
      priceDiscountLeft: offer?.card?.[0]?.discount,
      priceLabelLeft: offer?.card?.[0]?.priceLabel,
      priceWithReduction: offer?.card?.[0]?.price,
    }),
    offerButton: {
      text: t('see_offer_button_text'),
      variant: ActionButtonVariant.secondary,
    },
    isLogin: isLogin,
  }
}
